<template>
<div>
  <v-breadcrumbs
    class="py-2 px-0"
    :items="aDataItems"
    divider=">"
    >
    <template v-slot:item="{ item }">
      <v-breadcrumbs-item class="titlesdark--text" :href="item.href">
        {{ item.text }}
      </v-breadcrumbs-item>
    </template>
  </v-breadcrumbs>
</div>
</template>
<script>
import axiosServices from "@/services/axiosServices.js"
import { mapGetters } from 'vuex';
export default {
  props:{
    aDataItems:{
      type: Array,
    }
  },
  data() {
    return {
      nombreUrl:'',
      itemsMenu:[
        {
          text: this.$store.state.jsIdioma.oEquivalencias.ttlInicio,
          disabled: true,
          href: '/Dashboard',
        },
        {
          text:''+this.sTitleModule+'',
        }
      ]
    }
  },
  mounted() {
    // console.log(this.$route.params.Modulo)    
    this.getMenuModules()
    // this.nombreUrl = this.$router.split("/")
  },
  methods: {
    getMenuModules() {
      if(!this.$store.state.login) return;  
      axiosServices.getConfiguration("/modulesMenu", true, `nIdModule=${this.sIdModule}&nIdPerfil=${this.$store.state.idPerfil}`)
      .then(aGetMenuModules => {
        this.itemsMenu = aGetMenuModules.aData;
      })
    },
  },
  computed:{
    sTitleModule() {
      let sTitleModule = this.getTitleModule;
      return sTitleModule
      // this.itemsMenu.push({text:''+sTitleModule+'',href:''+sTitleModule+''})
    },
    ...mapGetters(['getIdModule', 'getTitleModule'])
  }
}
</script>